import { Types } from "../actions/ReportBreakDownActions";

const initialState = {
    BreakdownReasonGroupList: {},
    BreakdownEffectList: {},
    AreaList: {},
    EquipmentMainList: {},
    EquipmentSubList: {},
    PoolList: {},
    BreakDownReasonPlaceList: {},
    UnPlannedMaintenanceCreateFile: {},
    EquipmentByBarCode: {},
    ReportBreakDownLoading: false,
};

export const ReportBreakDownReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_BREAKDOWN_REASONGROUP_LIST:
            return {
                ...state,
                BreakdownReasonGroupList: action.payload,
                ReportBreakDownLoading: false,
            };

        case Types.SET_BREAKDOWN_EFFECT_LIST:
            return {
                ...state,
                BreakdownEffectList: action.payload,
                ReportBreakDownLoading: false,
            };

        case Types.SET_AREA_LIST_IN_BREAKDOWN:
            return {
                ...state,
                AreaList: action.payload,
                ReportBreakDownLoading: false,
            };

        case Types.SET_BREAKDOWN_EQUIPMENT_GET_MAIN_LIST_BY_AREA_ID:
            return {
                ...state,
                EquipmentMainList: action.payload,
                ReportBreakDownLoading: false,
            };

        case Types.SET_EQUIPMENT_GET_SUB_LIST_BY_ID:
            return {
                ...state,
                EquipmentSubList: action.payload,
                ReportBreakDownLoading: false,
            };

        case Types.SET_POOL_LIST_IN_BREAKDOWN:
            return {
                ...state,
                PoolList: action.payload,
                ReportBreakDownLoading: false,
            };

        case Types.SET_BREAKDOWN_REASON_PLACE_GET_LIST_BY_GROUP_ID:
            return {
                ...state,
                BreakDownReasonPlaceList: action.payload,
                ReportBreakDownLoading: false,
            };

        case Types.SET_UNPLANNED_MAINTENANCE_CREATE_WITH_FILE:
            return {
                ...state,
                UnPlannedMaintenanceCreateFile: action.payload,
                ReportBreakDownLoading: false,
            };

        case Types.SET_EQUIPMENT_GET_BY_BARCODE_CONTEXT:
            return {
                ...state,
                EquipmentByBarCode: action.payload,
                ReportBreakDownLoading: false,
            };

        default:
            return state;
    }
};
